/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.

import loadable from '@loadable/component';
// Project/bavaria-no
const BaseMetaTags = loadable(() => import('../../src/Project/bavaria-no/components/BaseMetaTags'));
const LayoutPlaceholderErrorComponent = loadable(() => import('../../src/Project/bavaria-no/components/LayoutPlaceholderErrorComponent'));
const MetaTags = loadable(() => import('../../src/Project/bavaria-no/components/MetaTags'));
const NotFound = loadable(() => import('../../src/Project/bavaria-no/components/NotFound'));


const Article = loadable(() => import('../components/Article'));
const ArticleList = loadable(() => import('../components/ArticleList'));
const CheckoutComplete = loadable(() => import('../components/CheckoutComplete'));
const GoogleMap = loadable(() => import('../components/GoogleMap'));
const JssForm = loadable(() => import('../components/JssForm'));
const ProductDetail = loadable(() => import('../components/ProductDetail'));
const ProductList = loadable(() => import('../components/ProductList'));
const ResellerDetail = loadable(() => import('../components/ResellerDetail'));
const ServiceBooking = loadable(() => import('../components/ServiceBooking'));
const SiteDecription = loadable(() => import('../components/SiteDecription'));
const SiteDepartments = loadable(() => import('../components/SiteDepartments'));
const SiteDetail = loadable(() => import('../components/SiteDetail'));
const SiteList = loadable(() => import('../components/SiteList'));
const SiteSelection = loadable(() => import('../components/SiteSelection'));
const TeaserBlockFixedIds = loadable(() => import('../components/TeaserBlockFixedIds'));
const TeaserBlockLatestAddition = loadable(() => import('../components/TeaserBlockLatestAddition'));
const TeaserBlockSelection = loadable(() => import('../components/TeaserBlockSelection'));
const AccordionDistribution = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/AccordionDistribution'));
const AccordionRetail = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/AccordionRetail'));
const AnimatedGraph = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/AnimatedGraph'));
const Blurb = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Blurb'));
const BrandList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/BrandList'));
const BrandLogoList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/BrandLogoList'));
const BreadCrumbs = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/BreadCrumbs'));
const Carousel = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Carousel'));
const CarModelCardList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/CarModelCardList'));
const CarouselWithThumbnails = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/CarouselWithThumbnails'));
const ContentWidgetIcon = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/ContentWidgetIcon'));
const ContentWidgetImage = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/ContentWidgetImage'));
const ContentWidgetLink = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/ContentWidgetLink'));
const CTABanner = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/CTABanner'));
const CountryList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/CountryList'));
const HeaderBody = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HeaderBody'));
const HeroBanner = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HeroBanner'));
const HeroNotFound = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HeroNotFound'));
const HeroVideoBanner = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HeroVideoBanner'));
const HeroWithCTA = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HeroWithCTA'));
const Highlight = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Highlight'));
const HighlightList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HighlightList'));
const HtmlRaw = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/HtmlRaw'));
const FAQList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/FAQList'));
const Footer = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Footer'));
const Iframe = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Iframe'));
const LinkCarousel = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/LinkCarousel'));
const Navigation = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Navigation'));
const NavigoCarCardList = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/NavigoCarCardList'));
const NewCarousel = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/NewCarousel'));
const NewCarouselSlide = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/NewCarouselSlide'));
const NewsLetterHeader = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/NewsLetterHeader'));
const RichContentBlock = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/RichContentBlock'));
const SearchBar = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/SearchBar'));
const StageRow = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/StageRow'));
const StageRowMedia = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/StageRowMedia'));
const Table = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/Table'));
const YoutubeVideo = loadable(() => import('@hedinbil/hedin-ui/dist/base/components/YoutubeVideo'));
const components = new Map();

// Project/bavaria-no
components.set('BaseMetaTags', BaseMetaTags);
components.set('LayoutPlaceholderErrorComponent', LayoutPlaceholderErrorComponent);
components.set('MetaTags', MetaTags);
components.set('NotFound', NotFound);


components.set('Article', Article);
components.set('ArticleList', ArticleList);
components.set('CheckoutComplete', CheckoutComplete);
components.set('GoogleMap', GoogleMap);
components.set('JssForm', JssForm);
components.set('ProductDetail', ProductDetail);
components.set('ProductList', ProductList);
components.set('ResellerDetail', ResellerDetail);
components.set('ServiceBooking', ServiceBooking);
components.set('SiteDecription', SiteDecription);
components.set('SiteDepartments', SiteDepartments);
components.set('SiteDetail', SiteDetail);
components.set('SiteList', SiteList);
components.set('SiteSelection', SiteSelection);
components.set('TeaserBlockFixedIds', TeaserBlockFixedIds);
components.set('TeaserBlockLatestAddition', TeaserBlockLatestAddition);
components.set('TeaserBlockSelection', TeaserBlockSelection);
components.set('AccordionDistribution', AccordionDistribution);
components.set('AccordionRetail', AccordionRetail);
components.set('AnimatedGraph', AnimatedGraph);
components.set('Blurb', Blurb);
components.set('BrandList', BrandList);
components.set('BrandLogoList', BrandLogoList);
components.set('BreadCrumbs', BreadCrumbs);
components.set('Carousel', Carousel);
components.set('CarModelCardList', CarModelCardList);
components.set('CarouselWithThumbnails', CarouselWithThumbnails);
components.set('ContentWidgetIcon', ContentWidgetIcon);
components.set('ContentWidgetImage', ContentWidgetImage);
components.set('ContentWidgetLink', ContentWidgetLink);
components.set('CTABanner', CTABanner);
components.set('CountryList', CountryList);
components.set('HeaderBody', HeaderBody);
components.set('HeroBanner', HeroBanner);
components.set('HeroNotFound', HeroNotFound);
components.set('HeroVideoBanner', HeroVideoBanner);
components.set('HeroWithCTA', HeroWithCTA);
components.set('Highlight', Highlight);
components.set('HighlightList', HighlightList);
components.set('HtmlRaw', HtmlRaw);
components.set('FAQList', FAQList);
components.set('Footer', Footer);
components.set('Iframe', Iframe);
components.set('LinkCarousel', LinkCarousel);
components.set('Navigation', Navigation);
components.set('NavigoCarCardList', NavigoCarCardList);
components.set('NewCarousel', NewCarousel);
components.set('NewCarouselSlide', NewCarouselSlide);
components.set('NewsLetterHeader', NewsLetterHeader);
components.set('RichContentBlock', RichContentBlock);
components.set('SearchBar', SearchBar);
components.set('StageRow', StageRow);
components.set('StageRowMedia', StageRowMedia);
components.set('Table', Table);
components.set('YoutubeVideo', YoutubeVideo);
export default function componentFactory(componentName) {
  return components.get(componentName);
};
